import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import BrandSection from './components/BrandSection';
import CTASection from './components/CTASection';
import { articleContent } from '@/mocks/articleContent';
import { SITE_URL } from '@/constants/site';

const faqSection = articleContent.sections.find((s) => s.id === 'faq');
const faqItems = faqSection?.faqItems ?? [];

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Kakobuy Finds — Discover the Best Kakobuy Spreadsheet Products & Shopping Guides',
  description:
    'Access the latest Kakobuy Spreadsheet resources, product databases, comparison guides, and expert shopping insights. Find trending products faster with organized spreadsheet collections covering Shoes, Hoodies, T-Shirts, Jackets, Accessories and more.',
  url: SITE_URL + '/',
  about: {
    '@type': 'Thing',
    name: 'Kakobuy Spreadsheet',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Kakobuy Finds',
    url: SITE_URL + '/',
  },
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
      />

      <Header />

      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <BrandSection />
        <ArticleSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}